import React, { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";

export const Collapsible = ({ title, count, defaultOpen = true, testId, children, right }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border border-[#E9ECEF] rounded-sm bg-white" data-testid={testId}>
      <div className="w-full flex items-center justify-between px-4 py-2.5 text-left">
        <button type="button" onClick={() => setOpen(!open)} className="flex items-center gap-2 flex-1 text-left" data-testid={testId ? `${testId}-toggle` : undefined}>
          {open ? <ChevronDown size={14} className="text-[#6C757D]" /> : <ChevronRight size={14} className="text-[#6C757D]" />}
          <span className="text-[11px] uppercase tracking-[0.2em] font-bold text-[#0B132B]">{title}</span>
          {count != null && <span className="text-[10px] px-1.5 h-4 rounded-full bg-[#F1F3F5] text-[#6C757D] font-bold grid place-items-center">{count}</span>}
        </button>
        {right}
      </div>
      {open && <div className="px-4 pb-4">{children}</div>}
    </div>
  );
};
